<template>
  <div class="wrapper">
    <van-nav-bar fixed title="我的公告" left-arrow @click-left="()=>{$router.go(-1)}" />
    <div class="content-wrapper mb-4" style="background-color: #f7f8fa;">
      <div class="invert-wrapper">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
          <b-row>
            <b-col cols="12" v-for="(item,index) in list" :key="index" @click="details(item.id)">
              <b-card class="mt-3 card-icon-bg card-icon-bg-primary o-hidden">
                <div class="content wrapper">
                  <h6 class="card-title">{{item.title}}</h6>
                  <span>{{item.creationTime}}</span>
                </div>
                <div class="content wrapper">
                  <span>{{item.content}}</span>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </van-list>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import meheader from "@/components/meheader";
export default {
  components: {
    meheader,
  },
  name: "enterprise",
  data() {
    return {
      visible: true,
      selcked: 1,
      list: [],
      loading: false,
      finished: false,
      PageIndex: 0,
    };
  },
  methods: {
    onLoad() {
      this.PageIndex += 1;
      this.request({
        url: "/v1.0/ThePublic/getUserContentList",
        method: "GET",
        params: {
          ContentType: 10,
          PageSize: 5,
          PageIndex: this.PageIndex,
        },
      }).then((res) => {
        if (res.success) {
          res.data.items.map((item) => {
            this.list.push(item);
          });
          if (res.data.totalCount == this.list.length) {
            this.finished = true;
          }
          this.loading = false;
        }
      });
    },
    details(id) {
      this.$router.push({
        name: "NoticeListDetails",
        params: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
.wrapper {
  width: 100%;
}
.content-wrapper {
  width: 100%;
  margin-top: 46px;
  .invert-wrapper {
    width: 90%;
    margin: 0 auto;
    .active {
      background-color: rgb(247, 248, 250);
    }
    .wrapper {
      display: flex;
      font-size: 10px;
      justify-content: space-between;
      & > span {
        display: inline-block;
      }
    }
  }
}
</style>
